import { render, staticRenderFns } from "./MapMarker.vue?vue&type=template&id=542bd881&scoped=true&"
import script from "./MapMarker.vue?vue&type=script&lang=js&"
export * from "./MapMarker.vue?vue&type=script&lang=js&"
import style0 from "./MapMarker.vue?vue&type=style&index=0&id=542bd881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542bd881",
  null
  
)

export default component.exports